import { Component } from '@angular/core';

@Component({
  selector: 'app-egyptian-citizenship',
  templateUrl: './egyptian-citizenship.component.html',
  styleUrl: './egyptian-citizenship.component.scss'
})
export class EgyptianCitizenshipComponent {

}
